import { render, staticRenderFns } from "./configuration-card.vue?vue&type=template&id=c0c8498a"
import script from "./configuration-card.vue?vue&type=script&lang=js"
export * from "./configuration-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports